<div *ngIf="loginOpen$ | async" class="grow--pos fill--pos fixed grid-max-width center z5 ms-xxlarge-t">
  <div class="relative ms-medium-t">
    <fin-login-form #loginForm [fullScreen]="mobileOrTablet" />
  </div>
</div>
<fin-login-widget #loginWidget [context]="context" />
